import { useSelector } from 'react-redux';
import { ImageAttributeProvider } from 'views/ProductPage/configurators/imageAttributeContext';
import { ProductMedia } from 'views/ProductPage/productMedia';
import { FavouriteToggle } from 'components/FavouriteToggle';
import {
  productIdSelector,
  brandWidgetSelector,
  brandUrlSelector,
  getProduct
} from 'views/ProductPage/selector';
import styles from './media.scss';
import Image from 'components/Shared/Image';
import { isMobileLayout } from 'components/Shared/responsive';
import { GtmProduct } from 'store/googleTagManager/types';
import { mapProductToGtm } from 'store/googleTagManager/events/utils';
import { withCurrentPage } from 'utils';

export const Media = () => {
  const productId = useSelector(productIdSelector);
  const brand = useSelector(brandWidgetSelector);
  const brandUrl = useSelector(brandUrlSelector);
  const mobile = useSelector(isMobileLayout);
  const product = useSelector(withCurrentPage(getProduct));

  const gtmProduct: GtmProduct = mapProductToGtm(product);

  const BRAND_LOGO_DIMENSIONS = {
    width: mobile ? 60 : 112,
    height: mobile ? 60 : 112
  };

  return (
    <div className={styles.media}>
      <ImageAttributeProvider>
        <ProductMedia />
      </ImageAttributeProvider>
      <FavouriteToggle className={styles.favourite} productId={productId} gtmProduct={gtmProduct} />
      {brand && brand.image.id !== '' && (
        <a href={brandUrl} className={styles.brandLogoWrapper}>
          <Image {...brand.image} {...BRAND_LOGO_DIMENSIONS} />
        </a>
      )}
    </div>
  );
};
